// extracted by mini-css-extract-plugin
export default {"about":"about_about__ZjGt9","about__title":"about_about__title__RV7YR"};